// KWANKGM02020_借入相談入力確認 参照画面
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import HeadingM from '../../molecules/HeadingM';
import FooterBorrowingConsultationPreview from '../../organisms/FooterBorrowingConsultationPreview';
import AgreementInfo from '../../templates/AgreementInfo';
import { KeyValue } from '../../types/KeyValue';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  has_debtor: boolean;
  handleClickChangeDetails: () => Promise<any>; // 「相談内容を変更する」のアクション
  agreement_info: KeyValue[];
}

const BorrowingConsultationPreview: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  callApi,
  guarantor_info,
  has_debtor,
  handleClickChangeDetails,
  agreement_info,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <HeadingM label="お申込情報"></HeadingM>
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      {/* 連帯債務者等が0人の場合は非表示、1人以上の場合は表示する */}
      {guarantors_num !== 0 && <AgreementInfo agreement_info={agreement_info} />}
      <FooterBorrowingConsultationPreview
        reception_id={reception_id}
        status_code={status_code}
        has_debtor={has_debtor}
        handleClickChangeDetails={handleClickChangeDetails}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingConsultationPreview;
